import { useDispatch, useSelector } from "react-redux";
import {
  addManualQuestion,
  getLaws,
  resetNewQuestionForm,
  setNewQuestionForm,
  setState,
} from "./redux/lawCollegeSlice";
import { useEffect } from "react";

export default function AddManualQuestion() {
  const { newQuestionForm, categories, selectedCategory } = useSelector(
    (state) => state.lawCollegeQuiz
  );
  const {
    question,
    option_a,
    option_b,
    option_c,
    option_d,
    correct_option,

    difficulty_level,
  } = newQuestionForm;

  const dispatch = useDispatch();
  const userStr = localStorage.getItem("user");
  const userId = userStr
    ? JSON.parse(userStr)?.id
    : JSON.parse(userStr)?.user_id
    ? null
    : "";
  useEffect(() => {
    if (userId) dispatch(getLaws());
    dispatch(
      setState({
        key: "selectedCategory",
        value: "",
      })
    );
  }, [dispatch]);
  const handleChange = (key, value) => {
    dispatch(setNewQuestionForm({ key, value }));
  };
  const isFormValid =
    question &&
    option_a &&
    option_b &&
    option_c &&
    option_d &&
    correct_option &&
    difficulty_level;
  const optionFields = [
    { label: "Option A", key: "option_a", value: option_a },
    { label: "Option B", key: "option_b", value: option_b },
    { label: "Option C", key: "option_c", value: option_c },
    { label: "Option D", key: "option_d", value: option_d },
    {
      label: "Correct Option",
      key: "correct_option",
      value: correct_option,
      isCorrect: true,
    },
    {
      label: "Select Question Difficulty Level",
      key: "difficulty_level",
      value: difficulty_level,
      isSelect: true,
    },
  ];

  const handleSubmit = async () => {
    try {
      if (!selectedCategory) {
        alert("Please select a law");
        return; // stop execution if law not selected
      }

      const payload = {
        created_by: userId || null, // make sure it always goes
        question,
        correct_option,
        option_A: option_a,
        option_B: option_b,
        option_C: option_c,
        option_D: option_d,
        level: difficulty_level,
        law: selectedCategory,
      };

      // console.log("Payload:", payload); // debug log

      const res = await dispatch(addManualQuestion(payload)).unwrap();

      // show response dynamically
      alert(
        res && typeof res === "object"
          ? res.message || "Question added successfully."
          : String(res) || "Question added successfully."
      );

      // clear form
      dispatch(resetNewQuestionForm());
      dispatch(setState({ key: "selectedCategory", value: "" }));
    } catch (error) {
      console.log("error got is ", error);
      if (error?.response?.status === 409) {
        alert("This question already exists.");
      } else {
        const errRes = error?.response?.data || error;

        alert(
          errRes && typeof errRes === "object"
            ? errRes.message || "Failed to add question."
            : String(errRes) || "Unknown error"
        );
      }
      dispatch(resetNewQuestionForm());
      dispatch(setState({ key: "selectedCategory", value: "" }));

      console.error("Error adding question:", error);
    }
  };

  return (
    <div className="container-fluid w-100 mx-auto py-2 font-inter">
      <div className="row mx-auto w-100">
        <div className="col-md-12 w-100">
          <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
            Manual Entry – Law College Quiz Questions{" "}
          </h3>

          <div className="bg-white mb-8 max-w-4xl mx-auto shadow rounded-3 p-4">
            {/* Full-width Question input */}
            <div className="row mb-3">
              <label className="col-sm-3 col-form-label font-medium text-gray-700">
                Question
              </label>
              <div className="col-sm-9.1">
                <input
                  type="text"
                  className="form-control"
                  value={question}
                  onChange={(e) => handleChange("question", e.target.value)}
                />
              </div>
            </div>

            {/* 2-in-a-row layout for remaining fields */}
            <div className="row">
              {optionFields.map((field, idx) => (
                <div className="col-md-6 mb-3" key={field.key}>
                  <label className="form-label text-gray-700 font-medium">
                    {field.label}
                  </label>
                  {field.isSelect ? (
                    <select
                      className="form-control"
                      value={field.value}
                      onChange={(e) => handleChange(field.key, e.target.value)}
                    >
                      <option value="">-- Select Level --</option>
                      <option value="basic">Basic Level</option>
                      <option value="advanced">Advanced Level</option>
                      <option value="ultra">Ultra Level</option>
                      <option value="docmaster">Docmaster</option>
                    </select>
                  ) : field.isCorrect ? (
                    <select
                      className="form-control"
                      value={field.value}
                      onChange={(e) => handleChange(field.key, e.target.value)}
                    >
                      <option value="">-- Select ---</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                    </select>
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      value={field.value}
                      onChange={(e) => handleChange(field.key, e.target.value)}
                    />
                  )}
                </div>
              ))}
            </div>
            <div className="row ">
              <label className="col-sm-3 col-form-label font-medium text-gray-700">
                Laws
              </label>
              {/* <div className="col-sm-9"> */}
              <select
                className="form-control"
                value={selectedCategory}
                // style={{width}}
                onChange={(e) =>
                  dispatch(
                    setState({
                      key: "selectedCategory",
                      value: e.target.value,
                    })
                  )
                }
              >
                <option>Select</option>
                {categories
                  ?.slice() // make a shallow copy to avoid mutating original array
                  .sort((a, b) => a.name.localeCompare(b.name)) // alphabetical sort
                  .map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.name}
                    </option>
                  ))}{" "}
              </select>
              {/* </div> */}
            </div>

            <div className="text-center mt-4">
              <button
                className="btn btn-primary px-4 py-2 rounded"
                disabled={!isFormValid}
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>

          <hr className="my-8 border-gray-300" />
        </div>
      </div>
    </div>
  );
}
